import React, { useState } from 'react'
import Classes from './Faq.module.css'
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';

export default function Faq() {
    const navigateTo = useNavigate();
    const [expanded, setExpanded] = useState('panel1');
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqs = [
        {
            question: "How does a Fuel Clubs membership work?",
            answer: "With a Fuel Clubs membership, you can schedule fuel deliveries directly to your home or business. Simply choose a plan, request a delivery through our app or website, and our team will arrive to refuel your vehicle or equipment on your scheduled day — no trips to the gas station needed."
        },
        {
            question: "What types of fuel do you deliver?",
            answer: "We deliver regular (87), Diesel , and premium (91–93) gasoline directly to your vehicle or equipment."
        },
        {
            question: "How often can I schedule deliveries?",
            answer: "You can schedule deliveries whenever you need them—whether it’s planned in advance or a last-minute request."
        },
        {
            question: "Is there an additional fee for same-day delivery?",
            answer: "No, there’s no extra fee for same-day deliveries."
        },
        {
            question: "Can I pause or cancel my membership?",
            answer: "Absolutely. You can pause your membership anytime without penalty, and you’re free to cancel whenever you choose. No hidden fees or long-term commitments."
        },
    ];

    return (
        <>
            <section id='faq' className={Classes.section}>
                <div className={Classes.faqsLeft} >
                    <div className={Classes.miniText} > FAQS </div>
                    <h1 className={Classes.subheading}> Frequently Asked <br /> Questions </h1>
                    <p className={Classes.text} >
                        Find answers to common questions about our membership plans and scheduling your fuel delivery. Need more help?
                        <span onClick={() => { navigateTo('/contact-us') }} style={{ color: 'var(--primary-color)', fontWeight: '600', cursor: 'pointer' }} > Contact us</span>.
                    </p>
                </div>

                <div id='questions' className={Classes.faqs}>
                    <div className={Classes.faqsCon}>
                        {faqs.map((faq, index) => (
                            <Accordion
                                key={index}
                                expanded={expanded === `panel${index + 1}`}
                                onChange={handleChange(`panel${index + 1}`)}
                                sx={{
                                    border: '1px solid #80808024',
                                    boxShadow: 'rgb(0 0 0 / 13%) 0px 1px 2px',
                                    marginBottom: '1rem',
                                    borderRadius: '7px !important',
                                    padding: '6px 20px !important',
                                    '&:before': {
                                        display: 'none',
                                    }
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index + 1}bh-content`}
                                    id={`panel${index + 1}bh-header`}
                                    sx={{
                                        minHeight: '32px !important',
                                        margin: '0 !important',
                                        padding: '0px 10px !important',
                                        '&.Mui-expanded': {
                                            margin: '0 !important',
                                            minHeight: '32px !important',
                                            padding: '0px 10px !important',
                                        },
                                        '.MuiAccordionSummary-content': {
                                            margin: '10px 0 !important'
                                        },
                                        '.MuiAccordionDetails-root': {
                                            padding: '8px 12px 16px !important'
                                        },
                                    }}
                                >
                                    <div className={Classes.AccordionHeader}>
                                        <h5>{faq.question}</h5>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className={Classes.accordinBody}
                                    sx={{
                                        padding: '8px 16px 16px 10px !important',
                                    }}
                                >
                                    <h5 className={Classes.accordionText}>{faq.answer}</h5>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </div>
                </div>

            </section>
        </>
    )
}
